import styled from 'styled-components';

export const StyledFavoritesWrap = styled.div`
    width: 100%;
    border-top: ${({ $simple }) => ($simple ? 'none' : '1px solid #D2D6DA')};
    padding: ${({ $simple }) => ($simple ? '48px 0 130px' : '48px 0 24px;')};
    position: relative;
`;
